module.exports = __webpack_public_path__ + "static/media/user.cba2a265.svg";